import { render, staticRenderFns } from "./SupplierDetailAccountStatement.vue?vue&type=template&id=0405d17b&scoped=true&"
import script from "./SupplierDetailAccountStatement.vue?vue&type=script&lang=js&"
export * from "./SupplierDetailAccountStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0405d17b",
  null
  
)

export default component.exports